// Browser-history integration for the compact calendar surface (KSE-0191):
// the full-screen event sheet (an occurrence is selected in the core) and the
// calendars bottom sheet each push one history entry, so the platform back
// gesture / Android back dismisses the sheet instead of leaving lately.org
// (or closing the installed PWA). Same machinery as the mail surface
// (useStackHistory); only the calendar's own layers are read or written.

import { useCallback, useRef } from "react";

import {
  CALENDAR_LAYERS,
  desiredCalendarLayers,
  type HistoryLayer,
  popCalendarTo,
} from "../mail/navigation";
import { useStackHistory } from "../mail/useMailHistory";

export interface CalendarHistoryInput {
  /** compact viewport AND this surface is the active one. */
  compact: boolean;
  eventOpen: boolean;
  calendarsOpen: boolean;
  onPop: (open: { eventOpen: boolean; calendarsOpen: boolean }) => void;
}

export function useCalendarHistory({
  compact,
  eventOpen,
  calendarsOpen,
  onPop,
}: CalendarHistoryInput) {
  const onPopRef = useRef(onPop);
  onPopRef.current = onPop;
  const handlePop = useCallback(
    (layers: HistoryLayer[]) => onPopRef.current(popCalendarTo(layers)),
    [],
  );
  useStackHistory({
    layers: desiredCalendarLayers({ compact, eventOpen, calendarsOpen }),
    owned: CALENDAR_LAYERS,
    enabled: compact,
    onPop: handlePop,
  });
}
